// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"112": "8b287660","116": "4a41f847","122": "21a578a4","285": "4a7dbe9f","354": "9c6094ad","535": "1b822dcb","783": "76f7ceb9",}[chunkId] + ".js"
}